import income from './income/income'
import incomeData from "./data/incomeData";
import expense from "./expense/expense";
import saving from "./saving/saving";

export const benchmarks = {
  income: income(incomeData),
  expense,
  saving
}